import Carousel from '../legacy/components/carousel.js';

/**
 * Product Variants Carousel Component
 * Handles carousel functionality for product variant displays
 */
class ProductVariantsCarousel {
    constructor(container) {
        this.container = container;
        this.carousel = null;
        this.init();
    }

    init() {
        console.debug('ProductVariantsCarousel init');

        const { productsPerView, mobileProductsPerView } = this.container.dataset;

        this.perView = parseInt(productsPerView, 10) * 1.05; // 1.05 factor gives us a "peek"
        this.mobilePerView = parseInt(mobileProductsPerView, 10) * 1.05;

        this._initCarousel();
    }

    _initCarousel() {
        this.carousel = Carousel(this.container, {
            slidesPerView: this.mobilePerView,
            spaceBetween: 12,
            loop: false, // Don't loop for product variants
            breakpoints: {
                720: {
                    spaceBetween: 16,
                    slidesPerView: this.perView
                },
                1200: {
                    spaceBetween: 24,
                    slidesPerView: this.perView
                }
            }
        });
    }

    destroy() {
        console.debug('ProductVariantsCarousel destroy');
        if (this.carousel) {
            this.carousel.destroy();
            this.carousel = null;
        }
    }
}

// Initialize all product variants carousels on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    const carouselContainers = document.querySelectorAll('[data-product-variants-carousel]');
    const carouselInstances = [];

    carouselContainers.forEach((container) => {
        const instance = new ProductVariantsCarousel(container);
        carouselInstances.push(instance);
    });

    // Store instances globally for cleanup if needed
    window.productVariantsCarousels = carouselInstances;
});

export default ProductVariantsCarousel;
